export const JSON_META_SCHEMA_EN = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  $id: 'http://json-schema.org/draft-07/schema#',
  title: 'Core schema meta-schema',
  definitions: {
    schemaArray: {
      type: 'array',
      minItems: 1,
      items: {
        $ref: '#',
      },
      title: 'Schema Array',
      description: 'An array containing one or more valid JSON schemas',
      errorMessage: {
        type: 'Must be an array',
        minItems: 'Must contain at least one schema',
      },
    },
    nonNegativeInteger: {
      type: 'integer',
      minimum: 0,
      title: 'Non-negative Integer',
      description: 'An integer value that is greater than or equal to zero',
      errorMessage: {
        type: 'Must be an integer',
        minimum: 'Must be a non-negative number (>= 0)',
      },
    },
    nonNegativeIntegerDefault0: {
      allOf: [
        {
          $ref: '#/definitions/nonNegativeInteger',
        },
        {
          default: 0,
        },
      ],
      title: 'Non-negative Integer with Default Zero',
      description: 'A non-negative integer that defaults to 0 if not specified',
    },
    simpleTypes: {
      enum: ['array', 'boolean', 'integer', 'null', 'number', 'object', 'string'],
      title: 'Simple Types',
      description: 'The basic primitive types available in JSON Schema',
      errorMessage: {
        enum: 'Must be one of the allowed types: array, boolean, integer, null, number, object, string',
      },
    },
    stringArray: {
      type: 'array',
      items: {
        type: 'string',
      },
      uniqueItems: true,
      default: [],
      title: 'String Array',
      description: 'An array of unique string values',
      errorMessage: {
        type: 'Must be an array',
        items: 'All items must be strings',
        uniqueItems: 'All items must be unique',
      },
    },
  },
  type: ['object', 'boolean'],
  properties: {
    $id: {
      type: 'string',
      format: 'uri-reference',
      title: 'Schema Identifier',
      description: 'A unique identifier for the schema, typically a URI',
      errorMessage: {
        type: 'Must be a string',
        format: 'Must be a valid URI reference',
      },
    },
    $schema: {
      type: 'string',
      format: 'uri',
      title: 'Schema Dialect',
      description: 'The URI of the JSON Schema specification version that this schema follows',
      errorMessage: {
        type: 'Must be a string',
        format: 'Must be a valid URI',
      },
    },
    $ref: {
      type: 'string',
      format: 'uri-reference',
      title: 'Schema Reference',
      description: 'A URI reference to another schema or schema fragment',
      errorMessage: {
        type: 'Must be a string',
        format: 'Must be a valid URI reference',
      },
    },
    $comment: {
      type: 'string',
      title: 'Comment',
      description: 'A comment for schema authors, not used in validation',
      errorMessage: {
        type: 'Must be a string',
      },
    },
    title: {
      type: 'string',
      title: 'Title',
      description: 'A short descriptive title for the schema',
      errorMessage: {
        type: 'Must be a string',
      },
    },
    description: {
      type: 'string',
      title: 'Description',
      description: "A detailed explanation of the schema's purpose and usage",
      errorMessage: {
        type: 'Must be a string',
      },
    },
    default: true,
    readOnly: {
      type: 'boolean',
      default: false,
      title: 'Read Only',
      description: 'Indicates that a value should not be modified (used in hyperschema contexts)',
      errorMessage: {
        type: 'Must be a boolean value (true/false)',
      },
    },
    writeOnly: {
      type: 'boolean',
      default: false,
      title: 'Write Only',
      description: 'Indicates that a value may be set but should not be retrieved (e.g., passwords)',
      errorMessage: {
        type: 'Must be a boolean value (true/false)',
      },
    },
    examples: {
      type: 'array',
      items: true,
      title: 'Examples',
      description: 'An array of example values that are valid against this schema',
      errorMessage: {
        type: 'Must be an array',
      },
    },
    multipleOf: {
      type: 'number',
      exclusiveMinimum: 0,
      title: 'Multiple Of',
      description: 'Validates that a numeric value is a multiple of this number',
      errorMessage: {
        type: 'Must be a number',
        exclusiveMinimum: 'Must be greater than 0',
      },
    },
    maximum: {
      type: 'number',
      title: 'Maximum',
      description: 'The maximum value for a numeric instance (inclusive)',
      errorMessage: {
        type: 'Must be a number',
      },
    },
    exclusiveMaximum: {
      type: 'number',
      title: 'Exclusive Maximum',
      description: 'The maximum value for a numeric instance (exclusive)',
      errorMessage: {
        type: 'Must be a number',
      },
    },
    minimum: {
      type: 'number',
      title: 'Minimum',
      description: 'The minimum value for a numeric instance (inclusive)',
      errorMessage: {
        type: 'Must be a number',
      },
    },
    exclusiveMinimum: {
      type: 'number',
      title: 'Exclusive Minimum',
      description: 'The minimum value for a numeric instance (exclusive)',
      errorMessage: {
        type: 'Must be a number',
      },
    },
    maxLength: {
      $ref: '#/definitions/nonNegativeInteger',
      title: 'Maximum Length',
      description: 'The maximum length of a string instance',
    },
    minLength: {
      $ref: '#/definitions/nonNegativeIntegerDefault0',
      title: 'Minimum Length',
      description: 'The minimum length of a string instance',
    },
    pattern: {
      type: 'string',
      format: 'regex',
      title: 'Pattern',
      description: 'A regular expression that a string instance must match',
      errorMessage: {
        type: 'Must be a string',
        format: 'Must be a valid regular expression',
      },
    },
    additionalItems: {
      $ref: '#',
      title: 'Additional Items',
      description: 'Schema for validating array items not covered by the items keyword',
    },
    items: {
      anyOf: [
        {
          $ref: '#',
        },
        {
          $ref: '#/definitions/schemaArray',
        },
      ],
      default: true,
      title: 'Items',
      description: 'Schema or schemas for validating array items',
    },
    maxItems: {
      $ref: '#/definitions/nonNegativeInteger',
      title: 'Maximum Items',
      description: 'The maximum number of items allowed in an array',
    },
    minItems: {
      $ref: '#/definitions/nonNegativeIntegerDefault0',
      title: 'Minimum Items',
      description: 'The minimum number of items required in an array',
    },
    uniqueItems: {
      type: 'boolean',
      default: false,
      title: 'Unique Items',
      description: 'If true, all items in the array must be unique',
      errorMessage: {
        type: 'Must be a boolean value (true/false)',
      },
    },
    contains: {
      $ref: '#',
      title: 'Contains',
      description: 'Validates that at least one array item matches this schema',
    },
    maxProperties: {
      $ref: '#/definitions/nonNegativeInteger',
      title: 'Maximum Properties',
      description: 'The maximum number of properties allowed in an object',
    },
    minProperties: {
      $ref: '#/definitions/nonNegativeIntegerDefault0',
      title: 'Minimum Properties',
      description: 'The minimum number of properties required in an object',
    },
    required: {
      $ref: '#/definitions/stringArray',
      title: 'Required',
      description: 'An array of property names that must be present in the object',
    },
    additionalProperties: {
      $ref: '#',
      title: 'Additional Properties',
      description: 'Schema for validating properties not explicitly defined',
    },
    definitions: {
      type: 'object',
      additionalProperties: {
        $ref: '#',
      },
      default: {},
      title: 'Definitions',
      description: 'A container for reusable schema definitions referenced elsewhere',
      errorMessage: {
        type: 'Must be an object',
      },
    },
    properties: {
      type: 'object',
      additionalProperties: {
        $ref: '#',
      },
      propertyNames: {
        pattern: '^\\S+$',
      },
      default: {},
      title: 'Properties',
      description: 'Schema definitions for object properties',
      errorMessage: {
        type: 'Must be an object',
        propertyNames: 'Property names must not contain spaces',
      },
    },
    patternProperties: {
      type: 'object',
      additionalProperties: {
        $ref: '#',
      },
      propertyNames: {
        format: 'regex',
      },
      default: {},
      title: 'Pattern Properties',
      description: 'Schema definitions for properties matching regular expression patterns',
      errorMessage: {
        type: 'Must be an object',
        propertyNames: 'Property names must be valid regular expressions',
      },
    },
    dependencies: {
      type: 'object',
      additionalProperties: {
        anyOf: [
          {
            $ref: '#',
          },
          {
            $ref: '#/definitions/stringArray',
          },
        ],
      },
      title: 'Dependencies',
      description: 'Defines property or schema dependencies between object properties',
      errorMessage: {
        type: 'Must be an object',
      },
    },
    propertyNames: {
      $ref: '#',
      title: 'Property Names',
      description: 'Schema that all property names must validate against',
    },
    const: true,
    enum: {
      type: 'array',
      items: true,
      minItems: 1,
      uniqueItems: true,
      title: 'Enum',
      description: 'An array of allowed values; the instance must equal one of these values',
      errorMessage: {
        type: 'Must be an array',
        minItems: 'Must contain at least one value',
        uniqueItems: 'All values must be unique',
      },
    },
    type: {
      anyOf: [
        {
          $ref: '#/definitions/simpleTypes',
        },
        {
          type: 'array',
          items: {
            $ref: '#/definitions/simpleTypes',
          },
          minItems: 1,
          uniqueItems: true,
        },
      ],
      title: 'Type',
      description: 'The JSON type(s) that the instance must be',
      errorMessage: {
        anyOf: 'Must be either a simple type or an array of simple types',
      },
    },
    format: {
      type: 'string',
      title: 'Format',
      description: "Semantic validation for string values (e.g., 'email', 'date-time', 'uri')",
      errorMessage: {
        type: 'Must be a string',
      },
    },
    contentMediaType: {
      type: 'string',
      title: 'Content Media Type',
      description: "The MIME type of string content (e.g., 'application/json')",
      errorMessage: {
        type: 'Must be a string',
      },
    },
    contentEncoding: {
      type: 'string',
      title: 'Content Encoding',
      description: "The encoding used for string content (e.g., 'base64')",
      errorMessage: {
        type: 'Must be a string',
      },
    },
    if: {
      $ref: '#',
      title: 'If',
      description: "Conditional schema; used with 'then' and 'else' for conditional validation",
    },
    then: {
      $ref: '#',
      title: 'Then',
      description: "Schema to apply if the 'if' schema validates successfully",
    },
    else: {
      $ref: '#',
      title: 'Else',
      description: "Schema to apply if the 'if' schema fails validation",
    },
    allOf: {
      $ref: '#/definitions/schemaArray',
      title: 'All Of',
      description: 'The instance must validate against all of the provided schemas',
    },
    anyOf: {
      $ref: '#/definitions/schemaArray',
      title: 'Any Of',
      description: 'The instance must validate against at least one of the provided schemas',
    },
    oneOf: {
      $ref: '#/definitions/schemaArray',
      title: 'One Of',
      description: 'The instance must validate against exactly one of the provided schemas',
    },
    not: {
      $ref: '#',
      title: 'Not',
      description: 'The instance must not validate against this schema',
    },
  },
  default: true,
};
